import { render } from "./AchievementModal.vue?vue&type=template&id=a075d490"
import script from "./AchievementModal.vue?vue&type=script&lang=js"
export * from "./AchievementModal.vue?vue&type=script&lang=js"

import "./AchievementModal.vue?vue&type=style&index=0&id=a075d490&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__